import './project/editableDirective';
import './filters';
import './isOnScreenDirective';
import './loadingSpinnerDirective';
import './masonryDirectives';
import './modalDialogDirective';
import './smallDirectives';
import './validatorDirectives';
import './project/projectPageCanvasDirective';
import './stripeValidatorsDirectives';
import './formAutofillFixDirective';
import './project/CommentsDirective';
import './keypressDirective';
import './userAvatarDirective';
import './UserPopup';
import './toggleProjectModalDirective';
import './pickPreviewImageDirective';
import './smoothScrollDirective';
import './headroomDirective';
import './newsDirective';
import './project/projectAccessDirective';
import './searchDirective';
import './tabsDirective';
import './documentNoScroll';
import './oauthSignInButtons';
import './moreTextDirective';
import './project/ShareSocial';
import './project/ProjectPage';
import './Login';
import './ExplorePage';
import './scrollToDirective';
import './blurMeDirective';
import './project/LikeDirective';
import './ContentEditable';
import './Footer';
import './pauseHiddenPlayer';
import './AdBanner';
import './ProjectItem';
import './FixedTabs';
import './modalVideo';
import './LightLanding';
import './AppearAnimation';
import './landing/LandingPage';
import './landing/LandingComparisonPage';
import './RelatedPagesSwipable';
import './PressSwipable';
import './AutoplayVideo';
import './SearchText';
import './anmHeader';
import './waveHeader';
import './studioHeader';
import './commonLink';



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/index.ts